import fs from 'fs';
import path from 'path';
import pathsFunction, { locateProject } from './paths';

// Make sure that including paths.js after env.js will read .env variables.
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/config/env.ts", "<global>"],fileName: "/config/env.ts",childLine: 6,line: "delete require.cache[require.resolve('./paths')];"});
delete require.cache[require.resolve('./paths')];

/**
 * Configure all the dot env files
 */
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/config/env.ts", "<global>"],fileName: "/config/env.ts",childLine: 11,line: "export function configureDotenvFiles() {"});
export function configureDotenvFiles() {
	global.executions.addLine({className: "<global>",functionName: "configureDotenvFiles",hierarchy: ["/config/env.ts", "<global>", "configureDotenvFiles"],fileName: "/config/env.ts",childLine: 12,line: "\tconst paths = pathsFunction()"});
	const paths = pathsFunction()
	// There must be a NODE_ENV
	if (!process.env.NODE_ENV?.length) {
		global.executions.addLine({className: "<global>",functionName: "configureDotenvFiles",hierarchy: ["/config/env.ts", "<global>", "configureDotenvFiles"],fileName: "/config/env.ts",childLine: 15,line: "\t\tthrow new Error("});
		throw new Error(
			'The NODE_ENV environment variable is required but was not specified.'
		);
	}

	// https://github.com/bkeepers/dotenv#what-other-env-files-can-i-use
	global.executions.addLine({className: "<global>",functionName: "configureDotenvFiles",hierarchy: ["/config/env.ts", "<global>", "configureDotenvFiles"],fileName: "/config/env.ts",childLine: 21,line: "\tconst dotenvFiles = ["});
	const dotenvFiles = [
		`${paths.dotenv}.${process.env.NODE_ENV}.local`,
		// Don't include `.env.local` for `test` environment
		// since normally you expect tests to produce the same
		// results for everyone
		...[process.env.NODE_ENV !== 'test' ? [`${paths.dotenv}.local`] : []].flat(),
		`${paths.dotenv}.${process.env.NODE_ENV}`,
		paths.dotenv,
	].filter(Boolean);
	
	// Load environment variables from .env* files. Suppress warnings using silent
	// if this file is missing. dotenv will never modify any environment variables
	// that have already been set.  Variable expansion is supported in .env files.
	// https://github.com/motdotla/dotenv
	// https://github.com/motdotla/dotenv-expand
	global.executions.addLine({className: "<global>",functionName: "configureDotenvFiles",hierarchy: ["/config/env.ts", "<global>", "configureDotenvFiles"],fileName: "/config/env.ts",childLine: 36,line: "\tdotenvFiles.forEach(dotenvFile => {"});
	dotenvFiles.forEach(dotenvFile => {
		if (fs.existsSync(dotenvFile as string)) {
			global.executions.addLine({className: "<global>",functionName: "[anonymous]",hierarchy: ["/config/env.ts", "<global>", "configureDotenvFiles", "[anonymous]"],fileName: "/config/env.ts",childLine: 38,line: "\t\t\trequire('dotenv-expand')("});
			require('dotenv-expand')(
				(require('dotenv') as typeof import('dotenv')).config({
					path: dotenvFile,
					override: true
				})
			);
		}
	});

	global.executions.addLine({className: "<global>",functionName: "configureDotenvFiles",hierarchy: ["/config/env.ts", "<global>", "configureDotenvFiles"],fileName: "/config/env.ts",childLine: 47,line: "\treturn dotenvFiles"});
	return dotenvFiles
}
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/config/env.ts", "<global>"],fileName: "/config/env.ts",childLine: 49,line: "configureDotenvFiles()"});
configureDotenvFiles()

// We support resolving modules according to `NODE_PATH`.
// This lets you use absolute paths in imports inside large monorepos:
// https://github.com/facebook/create-react-app/issues/253.
// It works similar to `NODE_PATH` in Node itself:
// https://nodejs.org/api/modules.html#modules_loading_from_the_global_folders
// Note that unlike in Node, only *relative* paths from `NODE_PATH` are honored.
// Otherwise, we risk importing Node.js core modules into an app instead of webpack shims.
// https://github.com/facebook/create-react-app/issues/1023#issuecomment-265344421
// We also resolve them to make sure all tools using them work consistently.
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/config/env.ts", "<global>"],fileName: "/config/env.ts",childLine: 60,line: "export function configureNodePath() {"});
export function configureNodePath() {
	global.executions.addLine({className: "<global>",functionName: "configureNodePath",hierarchy: ["/config/env.ts", "<global>", "configureNodePath"],fileName: "/config/env.ts",childLine: 61,line: "\tconst appDirectory = locateProject(process.cwd())"});
	const appDirectory = locateProject(process.cwd())
	if (!appDirectory) {
		global.executions.addLine({className: "<global>",functionName: "configureNodePath",hierarchy: ["/config/env.ts", "<global>", "configureNodePath"],fileName: "/config/env.ts",childLine: 63,line: "\t\tthrow new Error(`No project.json found`)"});
		throw new Error(`No project.json found`)
	}
	
	global.executions.addLine({className: "<global>",functionName: "configureNodePath",hierarchy: ["/config/env.ts", "<global>", "configureNodePath"],fileName: "/config/env.ts",childLine: 66,line: "\tprocess.env.NODE_PATH = (process.env.NODE_PATH || '')"});
	process.env.NODE_PATH = (process.env.NODE_PATH || '')
		.split(path.delimiter)
		.filter(folder => folder && !path.isAbsolute(folder))
		.map(folder => path.resolve(appDirectory, folder))
		.join(path.delimiter);
}
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/config/env.ts", "<global>"],fileName: "/config/env.ts",childLine: 72,line: "configureNodePath()"});
configureNodePath()

/**
 * Get the client environment
 * @param publicUrl the public url of the client
 * @returns the process.env data
 */
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/config/env.ts", "<global>"],fileName: "/config/env.ts",childLine: 79,line: "function getClientEnvironment(publicUrl: string) {"});
function getClientEnvironment(publicUrl: string) {
	// Grab NODE_ENV and REACT_APP_* environment variables and prepare them to be
	// injected into the application via DefinePlugin in webpack configuration.
	global.executions.addLine({className: "<global>",functionName: "getClientEnvironment",hierarchy: ["/config/env.ts", "<global>", "getClientEnvironment"],fileName: "/config/env.ts",childLine: 82,line: "\tconst REACT_APP = /^REACT_APP_/i;"});
	const REACT_APP = /^REACT_APP_/i;

	global.executions.addLine({className: "<global>",functionName: "getClientEnvironment",hierarchy: ["/config/env.ts", "<global>", "getClientEnvironment"],fileName: "/config/env.ts",childLine: 84,line: "\tconst raw = Object.keys(process.env)"});
	const raw = Object.keys(process.env)
		.filter(key => REACT_APP.test(key))
		.reduce(
			(env, key) => {
				global.executions.addLine({className: "<global>",functionName: "raw",hierarchy: ["/config/env.ts", "<global>", "getClientEnvironment", "raw"],fileName: "/config/env.ts",childLine: 88,line: "\t\t\t\t(env as any)[key] = process.env[key];"});
				(env as any)[key] = process.env[key];
				global.executions.addLine({className: "<global>",functionName: "raw",hierarchy: ["/config/env.ts", "<global>", "getClientEnvironment", "raw"],fileName: "/config/env.ts",childLine: 89,line: "\t\t\t\treturn env;"});
				return env;
			},
			{
				// Useful for determining whether we’re running in production mode.
				// Most importantly, it switches React into the correct mode.
				NODE_ENV: process.env.NODE_ENV || 'development',
				// Useful for resolving the correct path to static assets in `public`.
				// For example, <img src={process.env.PUBLIC_URL + '/img/logo.png'} />.
				// This should only be used as an escape hatch. Normally you would put
				// images into the `src` and `import` them in code to get their paths.
				PUBLIC_URL: publicUrl,
				// We support configuring the sockjs pathname during development.
				// These settings let a developer run multiple simultaneous projects.
				// They are used as the connection `hostname`, `pathname` and `port`
				// in webpackHotDevClient. They are used as the `sockHost`, `sockPath`
				// and `sockPort` options in webpack-dev-server.
				WDS_SOCKET_HOST: process.env.WDS_SOCKET_HOST,
				WDS_SOCKET_PATH: process.env.WDS_SOCKET_PATH,
				WDS_SOCKET_PORT: process.env.WDS_SOCKET_PORT,
				// Whether or not react-refresh is enabled.
				// It is defined here so it is available in the webpackHotDevClient.
				FAST_REFRESH: process.env.FAST_REFRESH !== 'false',
			}
		);
	// Stringify all values so we can feed into webpack DefinePlugin
	global.executions.addLine({className: "<global>",functionName: "getClientEnvironment",hierarchy: ["/config/env.ts", "<global>", "getClientEnvironment"],fileName: "/config/env.ts",childLine: 114,line: "\tconst stringified = {"});
	const stringified = {
		'process.env': Object.keys(raw).reduce((env, key) => {
			global.executions.addLine({className: "<global>",functionName: "stringified",hierarchy: ["/config/env.ts", "<global>", "getClientEnvironment", "stringified"],fileName: "/config/env.ts",childLine: 116,line: "\t\t\t(env as any)[key] = JSON.stringify((raw as any)[key]);"});
			(env as any)[key] = JSON.stringify((raw as any)[key]);
			global.executions.addLine({className: "<global>",functionName: "stringified",hierarchy: ["/config/env.ts", "<global>", "getClientEnvironment", "stringified"],fileName: "/config/env.ts",childLine: 117,line: "\t\t\treturn env;"});
			return env;
		}, {}),
	};

	global.executions.addLine({className: "<global>",functionName: "getClientEnvironment",hierarchy: ["/config/env.ts", "<global>", "getClientEnvironment"],fileName: "/config/env.ts",childLine: 121,line: "\treturn { raw, stringified };"});
	return { raw, stringified };
}
export default getClientEnvironment;
